<template>
  <nav
    class="navbar is-fixed-top is-warning"
    role="navigation"
    aria-label="main navigation"
  >
    <div class="navbar-brand">
      <a class="navbar-item" href="/">
        <img
          alt="site logo"
          src="../assets/amadora_logo.png"
          width="70"
          height="70"
        />
      </a>

      <div
        class="navbar-burger"
        @click="showNav = !showNav"
        :class="{ 'is-active': showNav }"
      >
        <span aria-hidden="true" /> <span aria-hidden="true" />
        <span aria-hidden="true" />
      </div>
    </div>

    <div
      id="navbarBasicExample"
      class="navbar-menu"
      :class="{ 'is-active': showNav }"
    >
      <div>
        <ul class="navbar-start is-size-6 header-link">
          <li class="navbar-item">
            <router-link to="/" class="btn">අමාදොර</router-link>
          </li>
          <li class="navbar-item">
            <router-link to="/video" class="btn">විඩියෝ දේශනා</router-link>
          </li>
          <li class="navbar-item">
            <router-link to="/audio" class="btn">ඕඩියෝ දේශනා</router-link>
          </li>
          <li class="navbar-item">
            <router-link to="/articles/amadoraviwaraviya" class="btn"
              >ලිපි මාලාව</router-link
            >
          </li>
          <li class="navbar-item">
            <router-link to="/books" class="btn">දේශනා ග්‍රන්ථ</router-link>
          </li>
          <li class="navbar-item">
            <router-link to="/images" class="btn">සේයා රූ</router-link>
          </li>
          <li class="navbar-item">
            <router-link to="/about" class="btn">අප ගැන</router-link>
          </li>
        </ul>
      </div>

      <!-- Social icons -->
      <div class="navbar-end">
        <div class="navbar-item has-background-warning">
          <div class="buttons is-centered">
            <a
              class="button is-info"
              href="https://www.facebook.com/mahaaryawanshadeshanawa"
              target="_blank"
              rel="noopener noreferrer"
            >
              <font-awesome-icon
                :icon="{ prefix: 'fab', iconName: 'facebook' }"
              />
            </a>
            <a
              class="button is-danger"
              href="https://www.youtube.com/channel/UCgdaUnUmkHDpYCU0w2pR7Rw"
              target="_blank"
              rel="noopener noreferrer"
            >
              <font-awesome-icon
                :icon="{ prefix: 'fab', iconName: 'youtube' }"
              />
            </a>
            <a class="button is-info">
              <font-awesome-icon
                :icon="{ prefix: 'fab', iconName: 'twitter' }"
              />
            </a>
          </div>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  data() {
    return {
      showNav: false
    };
  }
};
</script>

<style scoped>
li:hover {
  border: 2rem;
  background-color: orange;
}

li {
  margin-top: 5px;
  /* transition: background-color ease-in; */
}
</style>
